











































import { Component, Mixins } from 'vue-property-decorator';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { resolveModule } from '@/store';
import ProviderAddDialog from '@/components/providers/ProviderAddDialog.vue';
import ProviderEditDialog from '@/components/providers/ProviderEditDialog.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { Provider } from '@/modules/backend/Entities/Provider';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';

@Component({
  mixins: [Mixin],
  components: {
    DataTableWrapper,
    'provider-add-dialog': ProviderAddDialog,
    'provider-edit-dialog': ProviderEditDialog
  }
})
export default class Providers extends Mixins(Mixin) {
  private readonly providers: ProvidersModule = resolveModule(ProvidersModule);

  private loading = false;

  private get items(): Provider[] {
    return this.providers.providers;
  }

  private get showFooter(): boolean {
    const MIN_ITEMS = 10;
    return this.items.length > MIN_ITEMS;
  }

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        value: 'id',
        sortable: false
      },
      {
        text: this.$t('screens.providers.dialog_fields.name').toString(),
        value: 'name'
      },
      {
        text: this.$t('screens.providers.dialog_fields.resources').toString(),
        sortable: false,
        value: 'resources'
      },
      {
        text: this.$t('common.table.headers.actions').toString(),
        sortable: false,
        value: 'Actions',
        align: 'end'
      }
    ];
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    await this.providers.fetch();
    this.loading = false;
  }

  public async mounted(): Promise<void> {
    await this.loadData();
  }
}
